import { FileIcon } from './file-icon';

export function getFileIcon(type: string): FileIcon {
  switch (type.split('/')[0]) {
    case 'text':
      return FileIcon.Text;
    case 'image':
      return FileIcon.Image;
    default:
      return FileIcon.Generic;
  }
}
